export default __webpack_public_path__ + "static/media/ajayi.6ff50112.png";